<script>
import {mapState} from 'vuex'

import { validateAndSubmit } from '../../../mixins/validateAndSubmit';
import { validationClass } from '../../../mixins/validationClass';

export default {
    data() {
        return {
            disableOnSubmit : false,
            clubAdmin :null
        }
    },

    props: [],

    mixins: [validateAndSubmit, validationClass],

    computed: {        
        'hasClub' : function() {
            return this.clubAdmin == 1 ? true : false;
        }

    },

    created() {

    },

    mounted() {
    },

    watch: {
    },

    methods: {
    },
}
</script>
